import { i18n } from 'boot/i18n';

export const SESSION_ACTIVITY_TYPES = {
  session: {
    value: 'session',
    icon: 'face',
    label: i18n.t('sessions.modals.sessionActivity.types.session'),
    required: true,
    displayOrder: 1,
    completeButton: i18n.t('sessions.modals.sessionActivity.completeNotesLabels.session'),
    editButton: i18n.t('sessions.modals.sessionActivity.editNotesLabels.session'),
    noteTemplateLabel: i18n.t('sessions.modals.sessionActivity.inputNoteTemplateLabels.session'),
    defaultAppointmentTitle: '',
  },
  supervision: {
    value: 'supervision',
    icon: 'supervised_user_circle',
    label: i18n.t('sessions.modals.sessionActivity.types.supervision'),
    required: true,
    displayOrder: 2,
    defaultAppointmentTitle: i18n.t('sessions.modals.sessionActivity.types.supervision'),
    completeButton: i18n.t('sessions.modals.sessionActivity.completeNotesLabels.supervision'),
    editButton: i18n.t('sessions.modals.sessionActivity.editNotesLabels.supervision'),
    noteTemplateLabel: i18n.t('sessions.modals.sessionActivity.inputNoteTemplateLabels.session'),
  },
  form: {
    value: 'form',
    icon: 'edit_note',
    label: i18n.t('sessions.modals.sessionActivity.types.form'),
    required: true,
    isNotEditable: true,
    displayOrder: 3,
    completeButton: i18n.t('sessions.modals.sessionActivity.completeNotesLabels.form'),
    editButton: i18n.t('sessions.modals.sessionActivity.editNotesLabels.form'),
    noteTemplateLabel: i18n.t('sessions.modals.sessionActivity.inputNoteTemplateLabels.form'),
    defaultAppointmentTitle: '',
  },
  break: {
    value: 'break',
    icon: 'restaurant',
    label: i18n.t('sessions.modals.sessionActivity.types.break'),
    displayOrder: 4,
    defaultAppointmentTitle: i18n.t('sessions.modals.sessionActivity.types.break'),
  },
  transportation: {
    value: 'transportation',
    icon: 'time_to_leave',
    label: i18n.t('sessions.modals.sessionActivity.types.transportation'),
    displayOrder: 5,
    defaultAppointmentTitle: i18n.t('sessions.modals.sessionActivity.types.transportation'),
    hasDistance: true,
  },
  incidentReport: {
    value: 'incidentReport',
    icon: 'support',
    label: i18n.t('sessions.modals.sessionActivity.types.incidentReport'),
    displayOrder: 6,
    defaultAppointmentTitle: '',
  },
  other: {
    value: 'other',
    icon: 'schedule',
    label: i18n.t('sessions.modals.sessionActivity.types.other'),
    displayOrder: 7,
    completeButton: i18n.t('sessions.modals.sessionActivity.completeNotesLabels.other'),
    editButton: i18n.t('sessions.modals.sessionActivity.editNotesLabels.other'),
    noteTemplateLabel: i18n.t('sessions.modals.sessionActivity.inputNoteTemplateLabels.other'),
    defaultAppointmentTitle: '',
  },
};

export const ACTIVITY_TYPES_ICONS = [
  'group',
  'laptop_mac',
  'phone',
  'co_present',
  'sticky_note_2',
  'safety_divider',
  'menu_book',
  'join_left',
  'draw',
  'interests',
  'emoji_emotions',
  'checklist',
  'design_services',
  'pause_presentation',
  'assignment',
  'cast_for_education',
  'sym_o_mop',
  'sym_o_clinical_notes',
  'adf_scanner',
  'construction',
];

export const SESSION_ACTIVITY_STATUSES = {
  CLOSED: 'closed',
  COMPLETED: 'completed',
  FINISHED: 'finished',
  IN_PROGRESS: 'in-progress',
  INTEGRATION_COMPLETED: 'integration-completed',
  OTHER: 'other',
  PENDING_REVIEW: 'pending-review',
  PENDING_SIGNATURES: 'pending-signatures',
  RENDERED: 'rendered',
};

export const ADDENDUM_STATUSES = {
  PENDING_SIGNATURES: 'pending-signatures',
  COMPLETE: 'complete',
};

export const ADDENDUM_TRACKED_APPOINTMENT_FIELDS = [
  'serviceCode',
  'placeOfServiceName',
  'placeOfServiceType',
  'placeOfServiceAddress',
];

// sessionActivity statuses shown for appointments with a linked activity
export const ACTIVITY_STATUSES_FOR_APPOINTMENTS = {
  PENDING_NOTES: 'finished',
  PENDING_REVIEW: 'pending-review',
  PENDING_SIGNATURES: 'pending-signatures',
  RENDERED: 'rendered',
};

export const APPOINTMENT_SOURCES = {
  CAMBER: 'camber',
  HI_RASMUS: 'hi_rasmus',
};
